import React, { useEffect, useMemo, useState } from "react";
import { TbLicense } from "react-icons/tb";
import { LuFileBadge } from "react-icons/lu";
import Button from "../../../components/Button/Button";
import Card from "../../../components/Card/Card";
import Container from "../../../components/Container/Container";
import Input from "../../../components/Input/Input";
import List from "../../../components/List/List";
import ModalComponent from "../../../components/Modal/ModalComponent";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import SearchInput from "../../../components/SearchInput/SearchInput";
import { useAuth } from "../../../contexts/auth";
import { useListManager } from "../../../contexts/list.manager";
import ClientLicenceService from "../../../services/ClientLicenceService";
import "./ConsultaLicencasECondominios.css";
import { Copy } from "../../../components/Copy/Copy";
import { DropdownMenu } from "../../../components/DropdownMenu/DropdownMenu";
import { BsCpu, BsThreeDots } from "react-icons/bs";
import { BiTransfer } from "react-icons/bi";
import { UnitSelector } from "../../../components/UnitSelector/UnitSelector";
import { MdBlock } from "react-icons/md";
import { subscribe, unsubscribe } from "../../../utils/events";
import LicenseService from "../../../services/LicensesService";

const ConsultaLicencasECondominios = (props) => {
	const [clientLicence, setClientLicence] = useState([]);
	const { user } = useAuth();
	const { lineSelected, setLineSelected } = useListManager();
	const [filters, setFilters] = useState("");

	const [ownerId, setOwnerId] = useState();
	const [showModalUpdateOwner, setShowModalUpdateOwner] = useState(false);
	const [showModalUpdateSN, setShowModalUpdateSN] = useState(false);
	const [newSerial, setNewSerial] = useState("");
	const [licenseSelected, setLicenseSelected] = useState(null);
	const [isLoading, setIsLoading] = useState(true);

	const getLicencesAndCondominio = async () => {
		setIsLoading(true);
		const resp = await ClientLicenceService.listLicencesAndCondominios(
			user.userData.selectedOrganizationId,
		);
		const list = Array.isArray(resp.data) ? resp.data : [];
		setClientLicence(list);
		setIsLoading(false);
	};

	useEffect(() => {
		getLicencesAndCondominio();
	}, [user, filters]);

	const transformedData = useMemo(() => {
		if (!Array.isArray(clientLicence)) return [];
		return clientLicence.map((item) => ({
			...item,
			bindingCode: item.bindingCode,
			serialNumber: item.serialNumber,
		}));
	}, [clientLicence]);

	const filteredData = useMemo(() => {
		if (!filters) return transformedData;
		return transformedData.filter((item) => {
			const searchLower = filters.toLowerCase();
			return (
				item.bindingCode.toLowerCase().includes(searchLower) ||
				item.serialNumber.toLowerCase().includes(searchLower) ||
				(item.name_local && item.name_local.toLowerCase().includes(searchLower))
			);
		});
	}, [transformedData, filters]);

	const handleSelectLicence = (licence) => {
		setLineSelected(licence);
	};

	const openUpdateModal = (licence) => {
		if (!licence) {
			alert("Selecione uma licença para atualizar o Serial Number.");
			return;
		}
		setNewSerial(licence.serialNumber);
		setLicenseSelected(licence);
		setShowModalUpdateSN(true);
	};

	const openUpdateOwnerModal = (licence) => {
		if (!licence) {
			alert("Selecione uma licença para atualizar o proprietário.");
			return;
		}
		setOwnerId(licence.id_owner);
		setLicenseSelected(licence);
		setShowModalUpdateOwner(true);
	};

	const handleUpdateSN = async () => {
		const response = await LicenseService.updateSerialNumber(
			licenseSelected.id,
			newSerial,
		);
		if (response.status === 200) {
			const updatedLicences = clientLicence.map((item) =>
				item.id === licenseSelected.id
					? { ...item, serialNumber: newSerial }
					: item,
			);
			setClientLicence(updatedLicences);
			setShowModalUpdateSN(false);
			setLicenseSelected(null);
		}
	};

	const handleUpdateOwner = async () => {
		const response = await LicenseService.transferToUnit(
			licenseSelected.id,
			ownerId,
		);
		if (response.data) {
			setShowModalUpdateOwner(false);
			setLicenseSelected(null);
		}
	};

	useEffect(() => {
		function onSseReceived(data) {
			if (
				['unitDeleted', 'licenseUpdated'].includes(data.action)
			) {
				getLicencesAndCondominio();
			}
		}
		subscribe('onSseReceived', onSseReceived);
		return () => unsubscribe('onSseReceived', onSseReceived);
	}, [])

	return (
		<div className="consulta-container">
			<div className="search-list-wrapper">
				<SearchContainer
					icon={<LuFileBadge size={20} />}
					title="Minhas Licenças"
					hideAddButton={true}
					aditionalButton1={
						lineSelected ? (
							<Button
								icon={<BsCpu size={20} />}
								label={
									lineSelected.serialNumber &&
										lineSelected.serialNumber !== "Sem equipamento"
										? "Atualizar Serial Number"
										: "Adicionar Serial Number"
								}
								className="button-blue backup-settings-button"
								onClick={openUpdateModal}
							/>
						) : null
					}
				>
					<SearchInput
						value={filters}
						placeholder="Buscar Licença"
						onChange={({ target }) => setFilters(target.value)}
					/>
				</SearchContainer>
				<Container>
					<div className="list-visibility">
						<List
							isLoading={isLoading}
							selectableRows={false}
							collumsObjIndex={[
								{
									collumnLabel: "Licença",
									index: "tag",
									type: "text",
								},
								{
									collumnLabel: "Número de série",
									index: "serialNumber",
									type: "text",
									// custom: ({ row }) => {
									// 	return (
									// 		<div className="flex flex-row items-center gap-3">
									// 			{row.serialNumber?.trim()?.length > 0 ? (
									// 				<span>{row.serialNumber}</span>
									// 			) : (
									// 				<span style={{ opacity: 0.36 }}>Não consta</span>
									// 			)}
									// 			<Button
									// 				className="button-link"
									// 				icon={<BsCpu size={18} />}
									// 				label={row.serialNumber?.trim()?.length > 0 ? "Atualizar" : "Adicionar"}
									// 				onClick={e => openUpdateModal(row)}
									// 			/>
									// 		</div>
									// 	);
									// }
								},
								{
									collumnLabel: "Senha",
									index: "tokenMqtt",
									type: "custom",
									custom: ({ row }) => {
										return (
											<Copy text={row.tokenMqtt} showText={true} onClick={(e) => e.stopPropagation()} />
										);
									}
								},
								{
									collumnLabel: "Data de Início",
									index: "start_date",
									type: "date",
								},
								{
									collumnLabel: "Data de Fim",
									index: "end_date",
									type: "date",
								},
								{
									collumnLabel: "Proprietário",
									index: "owner",
									type: "text",
								},
								{
									collumnLabel: "Alocado em",
									index: "name",
									type: "text",
								},
								{
									collumnLabel: "Habilitada",
									index: "enabled",
									type: "boolean",
								},
								{
									collumnLabel: "Ações",
									index: 'actions',
									type: "custom",
									custom: ({ row }) => {
										return (
											<DropdownMenu
												content={!row.hasOwnerAccess ? (
													<div className="p-1! flex flex-row items-center gap-2">
														<MdBlock size={18} />
														Sem permissão em {row.owner}
													</div>
												) : null}
												options={row.hasOwnerAccess ? [
													{
														icon: BsCpu,
														label: "Atualizar Serial Number",
														onClick: () => {
															openUpdateModal(row);
														},
													},
													{
														icon: BiTransfer,
														label: "Transferir",
														onClick: () => {
															openUpdateOwnerModal(row);
														},
													},
												] : []}
											/>
										);
									}
								}
							]}
							data={filteredData}
							onRowClick={handleSelectLicence}
						/>
					</div>

					<div className="card-visibility">
						{transformedData.map((licence, index) => (
							<Card
								key={index}
								data={licence}
								hideCardEditDeleteButtons={true}
								onClick={() => handleSelectLicence(licence)}
								style={{
									border:
										lineSelected?.id === licence.id ? "2px solid blue" : "none",
								}}
							>
								<p className="card-content-title">{licence.bindingCode}</p>
								<p className="card-content-title">{licence.serialNumber}</p>
								<p className="card-content">Condomínio: {licence.name}</p>
								<p className="card-content">
									Data de início: {licence.start_date}
								</p>
								<p className="card-content">Data de fim: {licence.end_date}</p>
								<p className="card-content">
									Habilitado: {licence.enabled ? "Sim" : "Não"}
								</p>
							</Card>
						))}
					</div>
				</Container>
				{/* Modal para atualizar o Serial Number */}
				<ModalComponent
					modalIsOpen={showModalUpdateSN}
					handleConfirm={handleUpdateSN}
					handleCancel={() => setShowModalUpdateSN(false)}
					modalText={
						newSerial ? "Atualizar Serial Number" : "Adicionar Serial Number"
					}
				>
					<div className="modal-input-container">
						<Input
							type="text"
							labelText={"Serial Number do Equipamento"}
							value={newSerial}
							onChange={({ target }) => setNewSerial(target.value)}
							placeholder="Digite o Serial Number"
						/>
					</div>
				</ModalComponent>
				{/* Modal para transferir */}
				<ModalComponent
					modalIsOpen={showModalUpdateOwner}
					handleConfirm={handleUpdateOwner}
					handleCancel={() => setShowModalUpdateOwner(false)}
					modalText={
						"Transferir para outro proprietário"
					}
				>
					<div className="modal-input-container w-full!">
						<UnitSelector
							modalTitle={"Selecione o proprietário"}
							inputLabel={"Selecione o proprietário"}
							parentId={ownerId ? `${ownerId}` : null}
							setParentId={id => setOwnerId(Number(id))}
						/>
					</div>
				</ModalComponent>
			</div>
		</div>
	);
};

export default ConsultaLicencasECondominios;
